// generated by srcset-codegen
import src from "./onboarding3.png";

const width = 438;
const height = 300;
export default { src, width, height };
